import SoundManager from '../utils/SoundManager.js';
import Config from '../utils/Config.js';
import Utils from '../utils/Utils';
import LocaleManager from '../utils/LocaleManager.js';
import StateButton from '../controls/StateButton.js';

export default class VerticalNumericStepper extends Phaser.Group {

    constructor(game, { availableValues, value, maxValue, minValue = 0, step = 1, label, formatFunction, bgImage })
    {
        super(game);

        if (typeof formatFunction !== 'function')
        {
            formatFunction = (num) => '' + num;
        }

        this.params = { availableValues, value, maxValue, minValue, step, label, formatFunction };

        this.onChange = new Phaser.Signal();

        const bg = this._bg = new Phaser.Image(game, 0, 0, bgImage || 'panels.more-less-bg');
        bg.rotation = (Math.PI * 90) / 180;
        bg.anchor.y = 1;
        this.addChild(bg);

        let buttonLess = this._buttonLess = new StateButton(game, 0, 0, 'buttons.minus', this._onClickLess, this);
        buttonLess.name = 'buttonLess';
        buttonLess.anchor.set(0.5);
        buttonLess.position.set(
            (bg.height >> 1) + 1,
            bg.width - (buttonLess.hitArea.width >> 1) - 2
        );
        this.addChild(buttonLess);

        let buttonMore = this._buttonMore = new StateButton(game, 0, 0, 'buttons.plus', this._onClickMore, this);
        buttonMore.name = 'buttonMore';
        buttonMore.anchor.set(0.5);
        buttonMore.position.set(
            buttonLess.x,
            (buttonMore.hitArea.width >> 1) + (Config.MobileDevice ? 0 : 2)
        );
        this.addChild(buttonMore);

        if (Config.MobileDevice)
        {
            buttonLess.hitArea = null;
            buttonMore.hitArea = null;
        }
        else
        {
            buttonLess.hitArea.x -= buttonLess.hitArea.width;
            buttonLess.hitArea.y -= buttonLess.hitArea.height;

            buttonMore.hitArea.x -= buttonMore.hitArea.width;
            buttonMore.hitArea.y -= buttonMore.hitArea.height;
        }

        this._defaultValueTextSize = 30;
        let valueText = this._valueText = new Phaser.Text(game, (bg.height >> 1) + 2, bg.width >> 1, '-', {
            font: Config.DEFAULT_FONT,
            fontSize: this._defaultValueTextSize,
            fontWeight: 'bold',
            fill: '#000000',
            align: 'center'
        });
        valueText.lineSpacing = -10;
        valueText.anchor.set(0.5);
        this.addChild(valueText);

        const localeFontSettings = {
          'cs': {
              fontSize: 10,
              lineSpacing: -4
          },
          'de': {
              fontSize: 10,
              lineSpacing: -4
          },
          'el': {
              fontSize: 12,
              lineSpacing: -4
          },
          'fi': {
              fontSize: 8,
              lineSpacing: -4
          },
          'hu': {
              fontSize: 10,
              lineSpacing: -4
          },
          'lv': {
              fontSize: 10,
              lineSpacing: -4
          },
          'pt': {
              fontSize: 10,
              lineSpacing: -4
          },
          'sr': {
              fontSize: 10,
              lineSpacing: -4
          },
          'tr': {
              fontSize: 12,
              lineSpacing: -4
          },
        }[LocaleManager.locale] || { fontSize: 16, lineSpacing: 0 };

        let labelText = this._labelText = new Phaser.Text(game, bg.height >> 1, 0, LocaleManager.getString(label), {
            font: Config.DEFAULT_FONT,
            fontSize: localeFontSettings.fontSize,
            fontWeight: 'bold',
            fill: '#FFFFFF',
            align: 'center'
        });
        labelText.lineSpacing = localeFontSettings.lineSpacing;
        labelText.anchor.set(0.5, 1);
        this.addChild(labelText);

        this.value = value;
    }

    get width()
    {
        return this._bg.width;
    }

    get height()
    {
        return this._bg.height;
    }

    get value()
    {
        return this._value || 0;
    }

    set value(num)
    {
        let formatFunction = this.params.formatFunction;
        let availableValues = this.params.availableValues;
        let effectiveValue = num;
        if (availableValues && availableValues.length)
        {
            let valueIndex = availableValues.indexOf(effectiveValue);
            if (valueIndex === -1)
            {
                effectiveValue = num;
            }
            else
            {
                effectiveValue = availableValues[valueIndex];
            }
        }
        else
        {
            if (effectiveValue > this.params.maxValue)
            {
                effectiveValue = this.params.maxValue;
            }
            else if (effectiveValue < this.params.minValue)
            {
                effectiveValue = this.params.minValue;
            }
        }

        this._valueText.text = formatFunction(effectiveValue);
        this._value = effectiveValue;

        this.adjustValueText();

        this.invalidateButtons();
    }

    setValueFontSize(value)
    {
        //this._forceValueFontSize = value;
        //this._valueText.fontSize = value;
    }

    adjustValueText()
    {
        return Promise.resolve(this._defaultValueTextSize);

        // for #149
        //return Utils.makeTimeoutPromise(0).then(() =>
        //{
        //    const label = this._valueText;
        //    label.fontSize = this._forceValueFontSize || this._defaultValueTextSize;
        //
        //    const neighbor = this._bg;
        //    const neighborBounds = neighbor.getBounds();
        //    for (let step = 0; step < 12; step++)
        //    {
        //        const labelBounds = label.getBounds();
        //        labelBounds.width += 2;
        //        labelBounds.y -= 4;
        //        if (!neighborBounds.containsRect(labelBounds))
        //        {
        //            label.fontSize = Math.max(10, label.fontSize - 2);
        //        }
        //        else
        //        {
        //            break;
        //        }
        //    }
        //
        //    return Promise.resolve(label.fontSize);
        //});
    }

    invalidateButtons()
    {
        let availableValues = this.params.availableValues;
        if (!this.enabled)
        {
            this._buttonMore.enabled = this._buttonLess.enabled = this.enabled;
        }
        else if (availableValues && availableValues.length)
        {
            let valueIndex = Math.max(0, availableValues.indexOf(this.value));
            this._buttonLess.enabled = valueIndex > 0;
            this._buttonMore.enabled = valueIndex < availableValues.length - 1;
        }
        else
        {
            this._buttonLess.enabled = this.value > this.params.minValue;
            this._buttonMore.enabled = this.value < this.params.maxValue;
        }
    }

    _onClickMore()
    {
        let availableValues = this.params.availableValues;
        let prevValue = this.value;
        if (availableValues && availableValues.length)
        {
            let valueIndex = Math.max(0, availableValues.indexOf(this.value));
            valueIndex = Math.min(valueIndex + 1, availableValues.length - 1);
            this.value = availableValues[valueIndex];
        }
        else
        {
            this.value += this.params.step;
        }

        this.onChange.dispatch(this, this.value, prevValue);
    }

    _onClickLess()
    {
        let availableValues = this.params.availableValues;
        let prevValue = this.value;
        if (availableValues && availableValues.length)
        {
            let valueIndex = Math.max(0, availableValues.indexOf(this.value));
            valueIndex = Math.max(0, valueIndex - 1);
            this.value = availableValues[valueIndex];
        }
        else
        {
            this.value -= this.params.step;
        }

        this.onChange.dispatch(this, this.value, prevValue);
    }

    get enabled()
    {
        return !!this._enabled;
    }

    set enabled(value)
    {
        this._enabled = value;
        this.invalidateButtons();
    }
}